module.exports = __webpack_public_path__ + "img/thank-logo-expand.22b8cfb3.png";